<template>
  <div id="app">
    <router-view/>
  </div>
</template>


<script>

export default {
  name: 'app',
  mounted: function() {
    this.onPageLoad()
  },

  methods: {
    onPageLoad: function() {

    },


  }
}
</script>
